import type { ReactNode } from 'react';

export function Abzeichen({
  ton = 'neutral',
  punkt = false,
  children,
}: {
  ton?: 'neutral' | 'gut' | 'warnung' | 'schlecht' | 'akzent';
  punkt?: boolean;
  children: ReactNode;
}) {
  return <span className={`dxl-abzeichen dxl-abzeichen--${ton}${punkt ? ' dxl-abzeichen--punkt' : ''}`}>{children}</span>;
}
